import React, { useState, useEffect } from "react";
import Share from "containers/share";
import BottomTip from "containers/bottom_tip";
import InitArea from "utils/block_text";
import { getRecordVisit } from "../../api/index";
import { getCheckVisit } from "api";
import "./index.less";
import { collectFunc } from "components";
import { achievementsID, keywordID } from "utils/consts";

const collectList = [
  "birthplace",
  "gloryhall",
  "friendship",
  "annualtrading",
  "spotcity ",
  "futuresfairyland ",
  "gatemetaverse",
  "startupcity",
  "earnhall",
  "ETFddomain",
  "NFTworld",
  "strategybot",
  "copytrading",
  "gatelearn",
  "gateworld",
  "gatelive",
  "gate.iomonument",
  "share",
  "gift",
];
export default function ClickArea({ props, directShowMap, showKeyword }) {
  const initArea = (props && InitArea(props)) || [];
  // const [showBottomTip, setShowBottomTip] = useState(true);
  const [showShare, setshowShare] = useState(false); //弹窗展示
  const [currentData, setCurrentData] = useState({ initArea }); //选中的数据
  const [clickList, setClickList] = useState([]);
  // 用户昵称
  const [userName, setUserName] = useState("Gater");
  // 首先展示Share block
  const [firstShowShareBlock, setfirstShowShareBlock] = useState(directShowMap);
  // 同步 NFT 是否已经选择
  const [alreadyChooseNFT, setAlreadyChooseNFT] = useState(false);
  const showKeywordRef = React.useRef(showKeyword);

  const clickMask = (data, index) => {
    // 去掉神秘礼物了，就不展示了
    let showMysteriousGift = false;
    return () => {
      // if(!data.text) return // 兼容无数据情况
      collectFunc({
        eventName: "annualbillpage_button_click",
        params: { button_name: collectList[index] },
      });
      setshowShare(true);
      setCurrentData({ ...currentData, data, index, showMysteriousGift });
      // 更新点击模块记录
      if (!clickList.includes(data.id)) {
        RecordVisit([...clickList, data.id]);
        setClickList([...clickList, data.id]);
      }
    };
  };

  // 已进入地图页，记录该用户为已经访问过
  const recordUserVisited = () => {
    getCheckVisit({ type: "update" }).then((res) => { });
  };

  useEffect(() => {
    if (showKeywordRef.current !== showKeyword) {
      const data = initArea.find((e) => e.id === keywordID);
      const dataIndex = initArea.findIndex((e) => e.id === keywordID);
      clickMask(data, dataIndex)();
      showKeywordRef.current = showKeyword;
    }
  }, [showKeyword]);

  useEffect(() => {
    RecordVisit();

    recordUserVisited();

    return () => {
      clearTimeout(timer);
    };
  }, []);
  // 查询点击模块记录
  const RecordVisit = (list) => {
    const params = list ? { type: "update", record_map: list } : {};
    getRecordVisit(params).then((res) => {
      if (!list) {
        if (res.data?.record_map) {
          let data = res.data?.record_map.flatMap((e) => Number(e));
          setClickList([...new Set([...data, ...clickList])]);
        }
      }
    });
  };
  // 详情切换  更新点击模块记录
  const switchingData = (result) => {
    collectFunc({
      eventName: "annualbillpage_button_click",
      params: { button_name: collectList[result.index] },
    });
    // 更新点击模块记录
    if (!clickList.includes(result.data.id)) {
      RecordVisit([...clickList, result.data.id]);
      setClickList([...clickList, result.data.id]);
    }
    setCurrentData(result);
  };

  let timer;

  return (
    <div className="click_area" id="click_area">
      {initArea.map((ele, index) => {
        if (
          ele.id === achievementsID &&
          firstShowShareBlock &&
          clickList.length
        ) {
          setfirstShowShareBlock(false);
          timer = setTimeout(() => {
            clickMask(ele, index)();
            clearTimeout(timer);
          }, 400);
        }
        return (
          <div
            key={ele.id}
            id={"click_area_" + ele.id}
            onClick={clickMask(ele, index)}
          >
            <span className={`click_area_title fw-700 checkBox`}>
              {ele.btnName}
            </span>
          </div>
        );
      })}
      {showShare && currentData.data && (
        <Share
          visibility={true}
          close={setshowShare}
          dataSoure={currentData}
          annualData={props?.transaction?.annual_data || {}}
          switchingData={switchingData}
          clickList={clickList}
          userName={userName}
          setAlreadyChooseNFT={setAlreadyChooseNFT}
        />
      )}
      <BottomTip />
    </div>
  );
}
